<template>
  <transition name="cmp-slide">
    <div v-if="visivel" class="cmp-card">
      <p class="cmp-card-eyebrow">{{ enviarIndividual ? "Mensagem" : "Passo 3 de " + totalPassos }}</p>
      <h3 class="cmp-card-title">Canal e mensagem</h3>

      <!-- Escolha do canal -->
      <label class="cmp-label">Canal de envio</label>
      <div class="cmp-choice-group mb-3">
        <div class="cmp-choice" :class="{ 'is-selected': canal === 'whatsapp' }" @click="$emit('selecionar-canal', 'whatsapp')">
          <div class="cmp-choice-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              <path d="M8 10h8M8 14h5"/>
            </svg>
          </div>
          <div><div class="cmp-choice-name">WhatsApp</div><div class="cmp-choice-desc">Mensagem via WhatsApp</div></div>
          <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
        </div>

        <div class="cmp-choice" :class="{ 'is-selected': canal === 'push' }" @click="$emit('selecionar-canal', 'push')">
          <div class="cmp-choice-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
          </div>
          <div><div class="cmp-choice-name">Push Notification</div><div class="cmp-choice-desc">Notificação na app</div></div>
          <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
        </div>
      </div>

      <!-- WhatsApp: template -->
      <div v-if="canal === 'whatsapp'" class="cmp-sub-field mb-3">
        <label class="cmp-label">Template WhatsApp</label>
        <div v-if="loadingTemplates" class="cmp-loading">A carregar templates...</div>
        <el-select v-else :value="templateSelecionado" filterable placeholder="Escolher template..."
          style="width:100%" @change="$emit('mudar-template-whatsapp', $event)"
          @input="$emit('update:templateSelecionado', $event)">
          <el-option v-if="templatesWhatsapp.length === 0" value="" label="Sem templates aprovados" disabled/>
          <el-option v-for="t in templatesWhatsapp" :key="t.value" :label="t.label" :value="t.label"/>
        </el-select>
        <div v-if="templateTemImagem" class="cmp-image-hint mt-2">
          <i class="ni ni-image mr-1"></i> Este template precisa de uma imagem no cabeçalho.
          <base-input :value="urlImagem" placeholder="URL da imagem..." class="mt-2 mb-1"
            @input="$emit('update:urlImagem', $event)"/>
          <dropzone-file-upload :value="fileSelecionado" accept="image/png, image/jpeg"
            @input="$emit('update:fileSelecionado', $event)"/>
        </div>
      </div>

      <!-- Push: template -->
      <div v-if="canal === 'push'" class="cmp-sub-field mb-3">
        <label class="cmp-label">Template Push</label>
        <div v-if="loadingTemplates" class="cmp-loading">A carregar templates...</div>
        <div v-else class="d-flex align-items-center" style="gap:8px">
          <el-select :value="templatePush" filterable placeholder="Escolher template..." style="flex:1"
            @change="$emit('aplicar-template-push', $event)"
            @input="$emit('update:templatePush', $event)">
            <el-option v-if="templatesPush.length === 0" value="" label="Sem templates guardados" disabled/>
            <el-option v-for="t in templatesPush" :key="t.value" :label="t.label" :value="t.value"/>
          </el-select>
          <base-button size="sm" type="neutral" @click="$emit('guardar-template')">Guardar</base-button>
        </div>
      </div>

      <!-- Mensagem -->
      <label class="cmp-label">Mensagem</label>
      <textarea
        :disabled="canal === 'whatsapp'"
        class="form-control cmp-textarea"
        :value="mensagem"
        rows="8"
        :placeholder="!canal ? 'Seleciona um canal primeiro...' : canal === 'whatsapp' ? 'Preenchido automaticamente pelo template...' : 'Escreve a mensagem aqui...'"
        @input="$emit('update:mensagem', $event.target.value)"
      ></textarea>
      <p v-if="canal === 'push' && mensagem && mensagem.trim().length < 30" class="cmp-error">
        A mensagem deve ter pelo menos 30 caracteres ({{ mensagem.trim().length }}/30).
      </p>

      <div class="cmp-actions mt-3">
        <base-button v-if="!enviarIndividual" type="neutral" size="md" @click="$emit('recuar')">
          <i class="ni ni-bold-left mr-1"></i> Voltar
        </base-button>
        <base-button type="primary" size="md" :disabled="!valido" @click="$emit('avancar')">
          Continuar <i class="ni ni-bold-right ml-1"></i>
        </base-button>
      </div>
    </div>
  </transition>
</template>

<script>
import { Select, Option } from "element-ui";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";

export default {
  name: "CampanhaPasso3",
  components: { [Select.name]: Select, [Option.name]: Option, DropzoneFileUpload },
  props: {
    visivel:            { type: Boolean, default: false },
    enviarIndividual:   { type: Boolean, default: false },
    totalPassos:        { type: Number,  default: 4 },
    canal:              { type: String,  default: "" },
    loadingTemplates:   { type: Boolean, default: false },
    templateSelecionado:{ default: null },
    templatesWhatsapp:  { type: Array,   default: () => [] },
    templateTemImagem:  { type: Boolean, default: false },
    urlImagem:          { type: String,  default: "" },
    fileSelecionado:    { default: null },
    templatePush:       { default: null },
    templatesPush:      { type: Array,   default: () => [] },
    mensagem:           { type: String,  default: "" },
    valido:             { type: Boolean, default: false },
  },
};
</script>
